<div class="mct-flex mct-row mct-justify-between mct-items-start">
  <div class="mct-flex mct-col" *ngIf="!expanded || loading">
    <span>{{ invoiceResult.InvoiceDescription }}</span>
    <em *ngIf="invoiceResult.LineItemsCount > 1" class="description">
      + {{ invoiceResult.LineItemsCount - 1 }} {{ invoiceResult.LineItemsCount - 1 | i18nPlural : otherLineItemMapping }}
    </em>
  </div>
  <div class="mct-flex mct-col" *ngIf="expanded && invoiceWithPayments">
    <span *ngFor="let lineItem of invoiceWithPayments.InvoiceLineItems">{{ lineItem.Descr ? lineItem.Descr : lineItem.Item }}</span>
  </div>
  <div
    *ngIf="invoiceResult && (invoiceResult.LineItemsCount > 1 || invoiceResult.AmountPaid > 0)"
    class="mct-flex mct-row mct-justify-start mct-items-center"
  >
    <wl-busy class="mr-5" [show]="loading"></wl-busy>
    <a (click)="toggleExpanded()">{{ buttonText | ucfirst }}</a>
  </div>
</div>
<div *ngIf="expanded && invoiceWithPayments && invoiceWithPayments.AmountPaid > 0" class="mct-flex mct-col">
  <div>
    <hr />
    <strong>{{ 'revenue.transactions-grid.expandable-description.payments' | translate | ucfirst }}:</strong>
    <div class="payment-row mct-flex mct-row mct-justify-between mct-items-center" *ngFor="let payment of invoicePayments">
      <span>{{ payment.PaymentType }} - {{ payment.PaymentDate | date : 'MM/dd/yyyy' }}</span>
      <span>{{ payment.Amount | currency }}</span>
    </div>
  </div>
</div>
